import React from "react";

import { Box, Collapse, Typography } from "@mui/material";

interface QuestionSlotProps {
  visible: boolean;
  label: string;
  children: React.ReactNode;
}

/**
 * Wraps a question field with a slide-in animation.
 * Questions appear sequentially as `visible` becomes true.
 */
export const QuestionSlot: React.FC<QuestionSlotProps> = ({ visible, label, children }) => (
  <Collapse in={visible} timeout={{ enter: 450, exit: 100 }} unmountOnExit>
    <Box sx={{ mb: 5 }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: "primary.main",
          letterSpacing: 1.2,
          textTransform: "uppercase",
          display: "block",
          mb: 2,
          fontSize: "0.67rem"
        }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  </Collapse>
);
